export const BASE_TIER_THRESHOLD = 10000;
export const MAX_THRESHOLD_MULTIPLIER = 1.25;
